import moment from 'moment';
import { getSelectorList } from '@/pages/dashboard/services/competitor';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'umi';
import {listFetchInterceptor} from "@/pages/dashboard/_config/filterListMap";
import { formatSortFiltersData } from '../../utils/_config/formatSortFiltersData';
import { getSelectorSchemeList } from '../../services/dashboardSetting';
import { getFilterSaveListVal } from '../../utils/utils';


export const useFilterData = (path: string) => {
  const [loading, setLoading] = useState(true); // 筛选器loading
  const [selectorSchemeList, setSelectorSchemeList] = useState([]);

  const { currentGame } = useSelector(state => {
    // @ts-ignore
    const { currentGame } = state.dashboard;
    return {
      currentGame
    }
  });

  const selectorRef = useRef<any>({
    gameCode: currentGame?.game_code
  });


  // 获取页面竞品页selector
  const getSelectorInfo = (gameCode: string): void => {
    getSelectorList({
      game_code: gameCode
    }).then(data => {
      const dataResult = formatSortFiltersData(data || {})
      
      selectorRef.current = {
        ...dataResult,
        gameCode,
        latestDate:{
          'dau':{
            date:data?.last_date?.daily_date || moment().format('YYYY-MM-DD'),
            hour:data?.last_date?.hour_date|| moment().format('YYYY-MM-DD'),
            week:data?.last_date?.weekly_date|| moment().format('YYYY-MM-DD'),
            month:data?.last_date?.monthly_date|| moment().format('YYYY-MM-DD'),
          },
          gameCode
        }
      }
      listFetchInterceptor(gameCode, dataResult)
    }).catch(e=>{
      console.log(e)
    }).finally(() => {
      setLoading(false);
    });
  };

  const getOutSelectorSchemeList = () => {
    getSelectorSchemeList(currentGame.game_code, path).then((res) => {
      setSelectorSchemeList(getFilterSaveListVal(res))
    })
  }
  
  // 初始化
  useEffect(() => {
    if (currentGame?.game_code) {

      Promise.all([getSelectorList({
        game_code: currentGame?.game_code,
      }), getSelectorSchemeList(currentGame.game_code, path)]).then(([data, res]) => {
        const dataResult = formatSortFiltersData(data || {})
        selectorRef.current = {
          ...dataResult,
          gameCode: currentGame?.game_code,
          latestDate:{
            'dau':{
              date:data?.last_date?.daily_date || moment().format('YYYY-MM-DD'),
              hour:data?.last_date?.hour_date|| moment().format('YYYY-MM-DD'),
              week:data?.last_date?.weekly_date|| moment().format('YYYY-MM-DD'),
              month:data?.last_date?.monthly_date|| moment().format('YYYY-MM-DD'),
            },
            gameCode: currentGame?.game_code,
          }
        }
        setSelectorSchemeList(getFilterSaveListVal(res))
        listFetchInterceptor(currentGame?.game_code, dataResult)
      }).catch((error)=>{
        console.log(error)
      }).finally(() => {
        setLoading(false)
      })
    }
  }, [currentGame]);

  return {
    loading,
    selectorSchemeList,
    getOutSelectorSchemeList,
    selector: selectorRef.current
  }
}
